// How long the "enter the experience" prompt waits for an answer before the visit is left.
// The seat is held for as long as the tab keeps renewing its lease, so an unanswered prompt
// costs a GPU slot until the tab goes away; leaving returns it.
export const entryPromptTimeout = 60_000; // milliseconds
